import { combineReducers } from 'redux'
import api from './api'
import termsOfUse from './termsOfUse'
import language from './language'
import auth from './auth'

export default combineReducers({
    api,
    termsOfUse,
    language,
    auth,
});
